import JsFunction from './JsFunction';

const eventTemplate = ({
  eventName,
  selectElementId,
  attrNameOfSelectedValue
}) => `document.addEventListener('${eventName}', function(e) {
  const advanceSelect = document.getElementById('${selectElementId}');
  const selectedElement = advanceSelect.getAttribute('${attrNameOfSelectedValue}');
  if (!selectedElement) return;
  [...advanceSelect.querySelectorAll("[annotationname]")].forEach(
    optionElement => {
      if (optionElement.value === selectedElement)
        optionElement.setAttribute("selected", true);
    }
  );
});`;

/**
 *    This template can be use to export the name of the event to used for
 *    event dispatching
 * @param {String} selectElementId - The id of the selectHtml element
 * @return {String} name of the event
 */
export const eventNameTemplate = (selectElementId) => `align${selectElementId}`;

export default class AdvanceSelect extends JsFunction {
  attrNameOfSelectedValue = 'selected-element';

  selectElement = '';

  eventName = '';

  attrNameOfSelectedValue = 'selected-element';

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.selectElement = htmlDom.getElementById(method.compIds);
    this.eventName = eventNameTemplate(this.selectElement.getAttribute('annotationname'));
  }

  printFunction() {
    this.functionality += eventTemplate({
      eventName: this.eventName,
      selectElementId: this.selectElement.id,
      attrNameOfSelectedValue: this.attrNameOfSelectedValue
    });
    return this.functionality;
  }
}
